import React, {useEffect, useState} from "react";
import {AgencyRepository} from "../repositories/AgencyRepository.ts";
import {AuthenticationRepository} from "../repositories/AuthenticationRepository.ts";
import {GetAgencyByIdUseCase} from "../domain/useCases/agencies/GetAgencyByIdUseCase.ts";
import {PacksTripbooksSection} from "./agencyDetail/PacksTripbooksSection.tsx";
import {CodeFormat} from "../domain/entities/Agency.ts";
import IconSpinner from '../assets/icons/spinner.svg?react';

const getAgencyByIdUseCase = new GetAgencyByIdUseCase(new AgencyRepository(new AuthenticationRepository()));

interface MyPacksTripbooksContainerProps {
    agencyId: string
}

// Raw fields the "Packs y TripBooks" view needs from `GET /agencies/{id}` —
// the Agency domain entity's `market` field doesn't match the API's actual
// `primaryMarket` property, so AgencyDetailContainer reads the raw response
// too rather than going through that type.
interface MyAgency {
    genericCode?: string
    primaryMarket?: string
    codeFormat?: CodeFormat
    numberOfPagesIncluded?: number
}

// Self-service equivalent of the "Packs y TripBooks" tab from AgencyDetailContainer
// (the tourOperator staff view of a specific agency), for a logged-in agency user
// looking at their own data.
export const MyPacksTripbooksContainer: React.FC<MyPacksTripbooksContainerProps> = ({agencyId}) => {
    const [agency, setAgency] = useState<MyAgency | null>(null)

    useEffect(() => {
        if (!agencyId) return
        getAgencyByIdUseCase.execute(agencyId).then(setAgency)
    }, [agencyId])

    if (!agency) {
        return (
            <div className="flex items-center justify-center h-full">
                <IconSpinner className="size-8"/>
            </div>
        )
    }

    return (
        <div className="h-full overflow-y-auto no-scrollbar">
            <PacksTripbooksSection
                agencyId={agencyId}
                genericCode={agency.genericCode}
                primaryMarket={agency.primaryMarket}
                numberOfPagesIncluded={agency.numberOfPagesIncluded}
                isSelfService
            />
        </div>
    )
}
